import { useMemo } from 'react';
import { useTheme } from 'foundations-theming/utils';
export function useFormThemeStyles(enabled = true) {
  const theme = useTheme();
  return useMemo(() => {
    var _t$body, _t$heading;
    if (!enabled) return {};
    const c = theme.color;
    const t = theme.typography;
    const br = theme.borderRadius;
    const vars = {
      '--hsf-button__background-color': c['fill-primary-default'],
      '--hsf-button__box-shadow': 'none',
      '--hsf-button__color': c['text-primary-default'],
      '--hsf-button__border-radius': br['100'],
      '--hsf-global__color': c['text-core-default'],
      '--hsf-field-label__color': c['text-core-default'],
      '--hsf-field-input__color': c['text-core-default'],
      '--hsf-field-textarea__color': c['text-core-default'],
      '--hsf-richtext__color': c['text-core-default'],
      '--hsf-heading__color': c['text-core-default'],
      '--hsf-field-description__color': c['text-core-subtle'],
      '--hsf-field-input__placeholder-color': c['text-core-subtle'],
      '--hsf-field-textarea__placeholder-color': c['text-core-subtle'],
      '--hsf-global-error__color': c['fill-alert-default'],
      '--hsf-field-input__background-color': c['fill-field-default'],
      '--hsf-field-textarea__background-color': c['fill-field-default'],
      '--hsf-field-checkbox__background-color': c['fill-field-default'],
      '--hsf-field-radio__background-color': c['fill-field-default'],
      '--hsf-field-input__border-color': c['border-core-default'],
      '--hsf-field-textarea__border-color': c['border-core-default'],
      '--hsf-field-checkbox__border-color': c['border-core-default'],
      '--hsf-field-radio__border-color': c['border-core-default'],
      '--hsf-field-input__border-radius': br['100'],
      '--hsf-field-textarea__border-radius': br['100'],
      '--hsf-background__border-radius': br['0'],
      '--hsf-background__background-color': c['fill-surface-default'],
      '--hsf-progressbar-progressLine__background-color': c['text-interactive-default']
    };
    const bodyFontFamily = (_t$body = t['body-200']) === null || _t$body === void 0 ? void 0 : _t$body.fontFamily;
    if (bodyFontFamily) {
      vars['--hsf-global__font-family'] = bodyFontFamily;
      vars['--hsf-field-input__font-family'] = bodyFontFamily;
      vars['--hsf-field-textarea__font-family'] = bodyFontFamily;
      vars['--hsf-field-label__font-family'] = bodyFontFamily;
      vars['--hsf-button__font-family'] = bodyFontFamily;
    }
    const headingFontFamily = (_t$heading = t['heading-300']) === null || _t$heading === void 0 ? void 0 : _t$heading.fontFamily;
    if (headingFontFamily) {
      vars['--hsf-heading__font-family'] = headingFontFamily;
    }
    return vars;
  }, [theme, enabled]);
}